<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    width?: string;
    height?: string;
    color?: string;
  }>(),
  {
    width: "1.5em",
    color: getCSSVar("--xg-red")
  }
);
</script>

<template>
  <svg
    viewBox="0 0 24 24"
    :width="props.width"
    :height="props.height ?? props.width"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="transform-origin: center"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12ZM19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z"
      :fill="props.color"
    />
    <path
      d="M12.5332 15.2001C12.5332 15.4946 12.2944 15.7334 11.9999 15.7334C11.7053 15.7334 11.4665 15.4946 11.4665 15.2001L11.4665 10.9334C11.4665 10.6388 11.7053 10.4001 11.9999 10.4001C12.2944 10.4001 12.5332 10.6388 12.5332 10.9334L12.5332 15.2001Z"
      :fill="props.color"
    />
    <path
      d="M12.5332 8.80006C12.5332 9.09462 12.2944 9.3334 11.9999 9.3334C11.7053 9.3334 11.4665 9.09462 11.4665 8.80006C11.4665 8.50551 11.7053 8.26673 11.9999 8.26673C12.2944 8.26673 12.5332 8.50551 12.5332 8.80006Z"
      :fill="props.color"
    />
  </svg>
</template>
